import templateUrl from './resourceListToolbar.html'

/**
 * Resource List toolbar component.
 *
 * Transcluded inside a {@link tmrResourceList Resource List} component.
 *
 * @example
 * <tmr-resource-list-toolbar
 *   breadcrumbs=""
 *   show-search-form-button=""
 *   show-add-button=""
 *   search-form-is-open=""
 *   breadcrumbs=""
 *   export-action=""
 *   hide-export=""
 *   on-click-search=""
 * ></tmr-resource-list-toolbar>
 *
 * @type {ngComponent}
 * @prop {boolean} show-search-form-button
 * @prop {boolean} search-form-is-open
 * @prop {array=} breadcrumbs
 * @prop {string=} [export-action="export"] The resource export query. See {@link TmrResource} for the default `exportQuery`
 * @prop {boolean} [hide-export=false]
 * @prop {function} on-click-search
 */
export const tmrResourceListToolbar = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrResourceListToolbarController',
  require: {
    resourceList: '^tmrResourceList',
  },
  bindings: {
    showSearchFormButton: '<',
    showAddButton: '<',
    searchFormIsOpen: '<',
    breadcrumbs: '<?',
    exportAction: '<?',
    hideExport: '<?',
    onClickSearch: '&',
  },
}

/**
 * Controller of component {@link tmrResourceListToolbar}.
 *
 * @type {ngController}
 */
export class tmrResourceListToolbarController {
  static ngType = 'controller'

  constructor($injector, $state, TmrToast) {
    'ngInject'
    Object.assign(this, { $injector, $state, TmrToast })
  }

  $onInit() {
    // resourcesCount is null when no search was performed,
    // for example when using the requireFilter option on the route
    this.noSearch = this.resourceList.resourcesCount === null

    // Default breadcrumbs: page title.
    this.breadcrumbs = this.breadcrumbs ?? [
      {
        translate: this.$state.current.label,
        suffix: this.noSearch ? null : ` (${this.resourceList.resourcesCount})`,
      },
    ]
    this.exportAction = this.exportAction ?? 'export'
  }

  export(format) {
    this.exporting = true
    this.resourceServiceObj =
      this.resourceServiceObj ??
      this.$injector.get(this.$state.current.resourceType)
    return this.resourceServiceObj[this.exportAction](format)
      .catch(err => this.TmrToast.exception(err))
      .finally(() => (this.exporting = false))
  }
}
